import { MEASUREMENTS_UNITS } from '@nike/ciclp-config';

export const calculatePossibleSlideIndex = (nextIndex, totalSlides) => {
  let indexToGo = nextIndex;
  if (indexToGo > totalSlides - 1) {
    indexToGo = totalSlides - 1;
  } else if (indexToGo < 0) {
    indexToGo = 0;
  }
  return indexToGo;
};

export const resolveImageMediaProps = (
  isDesktop,
  { portraitURL, landscapeURL } = {},
) => {
  const imgUrl = isDesktop ? portraitURL : landscapeURL;
  return {
    landscapeURL: imgUrl,
    portraitURL: imgUrl,
  };
};

export const getMeasuremerntUnits = translations => [
  {
    'aria-label': translations?.units_inch_a11y_label || 'inches on',
    id: 'inch',
    label: translations?.units_inch || 'in',
    value: MEASUREMENTS_UNITS.IMPERIAL,
  },
  {
    'aria-label': translations?.units_cm_a11y_label || 'centimeters on',
    id: 'cm',
    label: translations?.units_cm || 'cm',
    value: MEASUREMENTS_UNITS.METRIC,
  },
];

export const formatDropdownOptionValue = (value, units, translations) => {
  const unitText = getMeasuremerntUnits(translations).find(
    ({ value: unitName }) => unitName === units,
  )?.label;
  return `${value} ${unitText}`;
};
